import { render, staticRenderFns } from "./AssetTable.vue?vue&type=template&id=673b7aa4&scoped=true&"
import script from "./AssetTable.vue?vue&type=script&lang=js&"
export * from "./AssetTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetTable.vue?vue&type=style&index=0&id=673b7aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b7aa4",
  null
  
)

export default component.exports